define('MachineFit.View',
  [
    'AjaxRequestsKiller',
    'Backbone',
    'MachineFit.Model',
    'machine_fit.tpl',
    'jQuery',
    'underscore'
  ],
  function (
    AjaxRequestsKiller,
    Backbone,
    MachineFitModel,
    machine_fit_tpl,
    jQuery,
    _
  ) {
    'use strict';

    return Backbone.View.extend({
      template: machine_fit_tpl,

      initialize: function (options) {
        this.application = options.application;
        this.model = new MachineFitModel();
        this.item = options.item;
        this.itemId = this.item.internalid;
        this.machineFits = [];
        this.toFits = {};
        this.getMachineFits();
      },

      getMachineFits: function () {
        var self = this;
        return jQuery.when(
          this.model.fetch({
            killerId: AjaxRequestsKiller.getKillerId(),
            data: {
              itemId: this.itemId
            }
          }).done(function (results) {
            debugger;
            self.machineFits = results.mluRecs;
            self.toFits = results.crossRefRecs;
            self.render();
          })
        );
      },

      getContext: function () {
        return {
          machineFits: this.machineFits,
          toFits: this.toFits
        };
      }
    });
  });
